import { render, staticRenderFns } from "./OrdersOperator.vue?vue&type=template&id=39422f33&"
import script from "./OrdersOperator.vue?vue&type=script&lang=js&"
export * from "./OrdersOperator.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOperator.vue?vue&type=style&index=0&id=39422f33&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports